import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import React from 'react';
import check_circle_icon from '../../../../assets/pricing/check.svg';
import geminiIcon from '../../../../assets/pricing/aiProviders/gemini.png';
import chatgptIcon from '../../../../assets/pricing/aiProviders/chatgpt.png';
import claudeIcon from '../../../../assets/pricing/aiProviders/claude.png';
import copilotIcon from '../../../../assets/pricing/aiProviders/copilot.png';
import './PlanView.css';

const aiProviders = [
    { key: 'gemini', name: 'Gemini', icon: geminiIcon },
    { key: 'chatgpt', name: 'ChatGPT', icon: chatgptIcon },
    { key: 'claude', name: 'Claude', icon: claudeIcon },
    { key: 'copilot', name: 'Copilot', icon: copilotIcon },
];
const PlanView = ({ durationMode, currency }) => {
    const subscriptionCardsInfoMonthly = [
        {
            type: 'Compact',
            price: currency === 'usd' ? '$9' : '$15',
            details: [
                {
                    id: 1,
                    value: '4 Blockchain wallets', // Updated: 2 → 4 (DEV-3277)
                },
                {
                    id: 2,
                    value: 'Unlimited Tokens',
                },
                {
                    id: 3,
                    value: '100 Transactions',
                },
                {
                    id: 4,
                    value: 'Live & CSV imports',
                },
                {
                    id: 5,
                    value: 'CSV exports',
                },
            ],
        },
        {
            type: 'Starter',
            price: currency === 'usd' ? '$49' : '$79',
            details: [
                {
                    id: 1,
                    value: '10 Blockchain wallets', // Updated: 5 → 10 (DEV-3277)
                },
                {
                    id: 2,
                    value: 'Unlimited Tokens',
                },
                {
                    id: 3,
                    value: '500 Transactions',
                },
                {
                    id: 6,
                    value: 'Live & CSV imports',
                },
                {
                    id: 4,
                    value: 'Tax and portfolio',
                },
                {
                    id: 5,
                    value: 'Xero and QuickBooks Integration',
                },

            ],
        },
        {
            type: 'Premium',
            price: currency === 'usd' ? '$99' : '$159',
            details: [
                {
                    id: 2,
                    value: '20 Blockchain wallets', // Updated: 10 → 20 (DEV-3277)
                },
                {
                    id: 1,
                    value: 'Unlimited Tokens',
                },
                {
                    id: 3,
                    value: '5,000 Transactions',
                },
                {
                    id: 4,
                    value: 'Live & CSV imports',
                },
                {
                    id: 5,
                    value: 'Tax and portfolio',
                },
                {
                    id: 6,
                    value: 'Xero and QuickBooks Integration',
                },
                {
                    id: 7,
                    value: '10 AML check',
                },
            ],
        },
        {
            type: 'Pro',
            price: currency === 'usd' ? '$199' : '$320',
            details: [
                {
                    id: 2,
                    value: '40 Blockchain wallets', // Updated: 20 → 40 (DEV-3277)
                },
                {
                    id: 1,
                    value: 'Unlimited Tokens',
                },
                {
                    id: 3,
                    value: '10,000 Transactions',
                },
                {
                    id: 4,
                    value: 'Live & CSV imports',
                },
                {
                    id: 5,
                    value: 'Tax and portfolio',
                },
                {
                    id: 6,
                    value: 'Xero and QuickBooks Integration',
                },
                {
                    id: 7,
                    value: '20 AML check',
                },
            ],
        },
    ];
    const subscriptionCardsInfoYearly = [
        {
            type: 'Compact',
            price: currency === 'usd' ? '$97' : '$162',
            details: [
                {
                    id: 1,
                    value: '4 Blockchain wallets', // Updated: 2 → 4 (DEV-3277)
                },
                {
                    id: 2,
                    value: 'Unlimited Tokens',
                },
                {
                    id: 3,
                    value: '100 Transactions/ month',
                },
                {
                    id: 4,
                    value: 'Live & CSV imports',
                },
                {
                    id: 5,
                    value: 'CSV exports',
                },
            ],
        },
        {
            type: 'Starter',
            price: currency === 'usd' ? '$529' : '$853',
            details: [
                {
                    id: 1,
                    value: '10 Blockchain wallets', // Updated: 5 → 10 (DEV-3277)
                },
                {
                    id: 2,
                    value: 'Unlimited Tokens',
                },
                {
                    id: 3,
                    value: '500 Transactions/ month',
                },
                {
                    id: 6,
                    value: 'Live & CSV imports',
                },
                {
                    id: 4,
                    value: 'Tax and portfolio',
                },
                {
                    id: 5,
                    value: 'Xero and QuickBooks Integration',
                },

            ],
        },
        {
            type: 'Premium',
            price: currency === 'usd' ? '$1069' : '$1717',
            details: [
                {
                    id: 2,
                    value: '20 Blockchain wallets', // Updated: 10 → 20 (DEV-3277)
                },
                {
                    id: 1,
                    value: 'Unlimited Tokens',
                },
                {
                    id: 3,
                    value: '5,000 Transactions/ month',
                },
                {
                    id: 4,
                    value: 'Live & CSV imports',
                },
                {
                    id: 5,
                    value: 'Tax and portfolio',
                },
                {
                    id: 6,
                    value: 'Xero and QuickBooks Integration',
                },
                {
                    id: 7,
                    value: '10 AML check',
                },
            ],
        },
        {
            type: 'Pro',
            price: currency === 'usd' ? '$2146' : '$3456',
            details: [
                {
                    id: 2,
                    value: '40 Blockchain wallets', // Updated: 20 → 40 (DEV-3277)
                },
                {
                    id: 1,
                    value: 'Unlimited Tokens',
                },
                {
                    id: 3,
                    value: '10,000 Transactions/ month',
                },
                {
                    id: 4,
                    value: 'Live & CSV imports',
                },
                {
                    id: 5,
                    value: 'Tax and portfolio',
                },
                {
                    id: 6,
                    value: 'Xero and QuickBooks Integration',
                },
                {
                    id: 7,
                    value: '20 AML check',
                },
            ],
        },
    ];
    let data = subscriptionCardsInfoMonthly
    if (durationMode !== 'monthly') {
        data = subscriptionCardsInfoYearly;
    }
    return (
        <div className='row cardContainerPricing'>
            {
                data.map((card, index) => (
                    <div key={index} className='col subscriptionCards'>
                        <div className='card' style={{ border: 'unset' }}>
                            <div class="card-bodygg d-flex flex-column">
                                <div className='cardType'>
                                    {card.type}
                                </div>
                                <div className='cardPriceRow'>
                                    <div className='cardPrice'>
                                        {card.price}
                                    </div>
                                    <div className='cardDuration'>
                                        /{durationMode}
                                    </div>
                                </div>
                                <div className='cardQuote'>
                                    What's included
                                </div>
                                {
                                    card.details.map((detail) => (
                                        <div
                                            key={detail.id}
                                            className='cardDetail'
                                        >
                                            <img
                                                src={check_circle_icon}
                                                alt='check'
                                                className='cardImage'
                                            />
                                            <div className='cardDetailValue'>
                                                {detail.value}
                                            </div>
                                        </div>
                                    ))
                                }
                                <div className='cardDetail'>
                                    <img
                                        src={check_circle_icon}
                                        alt='check'
                                        className='cardImage'
                                    />
                                    <div className='cardDetailValue'>
                                        AI model connection
                                        <div className='cardAiLogos'>
                                            {aiProviders.map((provider) => (
                                                <img
                                                    key={provider.key}
                                                    src={provider.icon}
                                                    alt={provider.name}
                                                    title={provider.name}
                                                    className='cardAiLogo'
                                                />
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))
            }
        </div>
    );
};

export default PlanView;
